module.exports = "<div>\r\n  <edit entity-Management=\"$ctrl.$stateParams.entityManagement\" />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/entityManagement/entityContainer/entityContainer.html
// module id = 1200
// module chunks = 0